import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Button, IconButton, List, ListItem, ListItemText, Typography } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import { formatDocumentMeta } from "utils/documentMetaUtils";
import { getOriginalFileName } from "utils/utils";
import AddDocumentDialog from "./AddDocumentDialog";

const FlowDocuments = ({
  documents = [],
  onChange,
  addLabel = "Add document",
  readOnly = false,
}) => {
  const [open, setOpen] = useState(false);

  const handleRemove = (id) => {
    if (!window.confirm("Remove this document?")) return;
    onChange(documents.filter((d) => d.id !== id));
  };

  return (
    <div>
      {!readOnly && (
        <div className="flex justify-start mb-2">
          <Button
            size="small"
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => setOpen(true)}
          >
            {addLabel}
          </Button>
        </div>
      )}

      {documents.length === 0 ? (
        <Typography variant="body2" color="text.secondary" className="text-sm">
          No documents attached yet.
        </Typography>
      ) : (
        <List dense disablePadding className="border border-app-border rounded-lg divide-y">
          {documents.map((doc) => (
            <ListItem
              key={doc.id}
              secondaryAction={
                <>
                  <IconButton component={Link} to={doc.url} target="_blank" size="small">
                    <VisibilityOutlinedIcon fontSize="small" />
                  </IconButton>
                  {!readOnly && (
                    <IconButton size="small" color="error" onClick={() => handleRemove(doc.id)}>
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  )}
                </>
              }
            >
              <ListItemText
                primary={doc.name}
                secondary={
                  <>
                    <span className="block text-xs text-app-text-muted truncate">
                      {getOriginalFileName(doc.url)}
                    </span>
                    <span className="block text-xs text-app-text-muted mt-0.5">
                      {formatDocumentMeta(doc)}
                    </span>
                  </>
                }
                primaryTypographyProps={{ className: "text-sm font-medium" }}
              />
            </ListItem>
          ))}
        </List>
      )}

      <AddDocumentDialog
        open={open}
        title={addLabel}
        onClose={() => setOpen(false)}
        onAdd={(doc) => onChange([...documents, doc])}
      />
    </div>
  );
};

export default FlowDocuments;
